import { render, staticRenderFns } from "./formImport.pug?vue&type=template&id=2abb7784&lang=pug&"
import script from "./formImport.js?vue&type=script&lang=js&"
export * from "./formImport.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abb7784')) {
      api.createRecord('2abb7784', component.options)
    } else {
      api.reload('2abb7784', component.options)
    }
    module.hot.accept("./formImport.pug?vue&type=template&id=2abb7784&lang=pug&", function () {
      api.rerender('2abb7784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/forms/components/formImport/index.vue"
export default component.exports